
import React from "react";
import { FormBuilder } from "../../../../../components/form/FormBuilder";
import { addMedicationInventorySchema } from "../../../../../shared/static/forms/pharmacy/addMedicationInventoryForm";
import {
  MedicationInventory,
  Supplier,
} from "../../../../../interfaces/pharmacy";

export interface AddNewMedicationFormProps {
  onSubmit: (data: any) => void;
  onCancel: () => void;
  initialValues?: Partial<MedicationInventory>;
  suppliers: Supplier[];
}

export const AddNewMedicationForm: React.FC<AddNewMedicationFormProps> = ({
  onSubmit,
  initialValues,
  suppliers,
}) => {
  const formattedInitialValues = initialValues
    ? {
        ...initialValues,
        initialStock: initialValues.currentStock, // Map currentStock to initialStock for the form
      }
    : {};

  const supplierOptions = suppliers.map((s) => ({
    label: s.name,
    value: s.id,
  }));

  const schema = {
    ...addMedicationInventorySchema,
    properties: {
      ...addMedicationInventorySchema.properties,
      supplier: {
        ...addMedicationInventorySchema.properties.supplier,
        componentProps: {
          ...addMedicationInventorySchema.properties.supplier.componentProps,
          options: supplierOptions,
        },
      },
    },
  };

  return (
    <div className="py-4">
      <FormBuilder
        schema={schema as any}
        onSubmit={onSubmit}
        initialValues={formattedInitialValues}
        className="space-y-4"
      />
    </div>
  );
}; 